'use strict';

/*global services*/

function initialize($wrapper) {
    var sliderSlickSetting = {
        prevArrow: '<div data-role="none" class="banner__btn banner__btn--prev stop-click" aria-label="' + services.get('translator').trans('Previous') + '"><a href="#" title="' + services.get('translator').trans('Previous') + '"><i class="fa fa-chevron-left"></i></a></div>',
        nextArrow: '<div data-role="none" class="banner__btn banner__btn--next stop-click" aria-label="' + services.get('translator').trans('Next') + '"><a href="#" title="' + services.get('translator').trans('Next') + '"><i class="fa fa-chevron-right"></i></a></div>',
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000
    };

    $wrapper.find('.banner__list--reference').slick(sliderSlickSetting);

    var bannerSlickSetting = {
        prevArrow: '<div data-role="none" class="banner__btn banner__btn--prev stop-click" aria-label="' + services.get('translator').trans('Previous') + '"><a href="#" title="' + services.get('translator').trans('Previous') + '"><i class="fa fa-chevron-left"></i></a></div>',
        nextArrow: '<div data-role="none" class="banner__btn banner__btn--next stop-click" aria-label="' + services.get('translator').trans('Next') + '"><a href="#" title="' + services.get('translator').trans('Next') + '"><i class="fa fa-chevron-right"></i></a></div>',
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000
    };

    $wrapper.find('.banner__list--full').slick(bannerSlickSetting);

    /*
    var inlineBannerSlickSetting = {
        prevArrow: '<div data-role="none" class="slick-prev stop-click" aria-label="' + services.get('translator').trans('Previous') + '"><a href="#" title="' + services.get('translator').trans('Previous') + '"><i class="fa fa-chevron-left"></i></a></div>',
        nextArrow: '<div data-role="none" class="slick-next stop-click" aria-label="' + services.get('translator').trans('Next') + '"><a href="#" title="' + services.get('translator').trans('Next') + '"><i class="fa fa-chevron-right"></i></a></div>',
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        autoplay: false,
        autoplaySpeed: 3000
    };

    $wrapper.find('.inline-banner-slick').slick(inlineBannerSlickSetting);
    */

    var fancyboxSetting = {
        openEffect: 'elastic',
        closeEffect: 'elastic',
        closeBtn: false,
        helpers: {
            title: { type: 'inside' },
            buttons: {},
            overlay: { locked: false }
        }
    };
    $wrapper.find('.fancybox:not(.cycle-sentinel .fancybox)').fancybox(fancyboxSetting);
    $wrapper.find('.file').File();
}

jQuery('document').ready(function () {
    initialize(jQuery('body'));

    $('body').on('click', '.stop-click', function () {
        return false;
    });

    $().k2_top();
});
